import React, { useEffect } from 'react';
import './LoginPage.css';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Sparkles, LockKeyhole } from 'lucide-react';

export default function LoginPage() {
  const { login, loading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  return (
    <main className="login-page">
      <section className="login-shell">
        <div className="login-visual glass">
          <div className="login-brand">
            <div className="login-brand__logo">
              <ShieldCheck size={22} />
            </div>
            <div>
              <strong>Fantapp!</strong>
              <span>Fantasy Football Control Room</span>
            </div>
          </div>

          <h1>Accedi e gestisci le tue leghe.</h1>
          <p>
            Gestisce le tue aste, controlla i tuoi avversari e domina il campo.
          </p>

          <div className="login-pills">
            <span><Sparkles size={14} /> UI moderna</span>
            <span><LockKeyhole size={14} /> Sync in tempo reale</span>
          </div>
        </div>

        <div className="login-card glass">
          <div className="login-card__badge">Benvenuto</div>
          <h2>Entra con Google</h2>
          <p>Usa il tuo account Google per accedere alla home e ai dati dei giocatori.</p>

          <button className="login-button" onClick={login} disabled={loading}>
            {loading ? 'Accesso...' : 'Login con Google'}
          </button>

          <small>
            Dopo l’autenticazione verrai portato automaticamente alla dashboard.
          </small>
        </div>
      </section>
    </main>
  );
}